import { render, staticRenderFns } from "./ClickEffects.vue?vue&type=template&id=4cea77f6&scoped=true"
import script from "./ClickEffects.vue?vue&type=script&lang=js"
export * from "./ClickEffects.vue?vue&type=script&lang=js"
import style0 from "./ClickEffects.vue?vue&type=style&index=0&id=4cea77f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cea77f6",
  null
  
)

export default component.exports